import * as Icons from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "./Reveal";
import { motion } from "framer-motion";
import { SERVICES } from "../data/site";

// Secondary by design — supporting capabilities, not the headline.
export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-blue-600">
              Complementary Capabilities
            </span>
            <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-zinc-900">
              Selected services for teams adopting AI
            </h2>
            <p className="mt-4 text-base text-zinc-600 leading-relaxed">
              Alongside our products, we partner on a focused set of engagements — always
              measured by the outcomes they create for our customers.
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {SERVICES.map((s) => {
            const Icon = Icons[s.icon] || Icons.Boxes;
            return (
              <motion.div
                key={s.id}
                variants={staggerItem}
                whileHover={{ y: -4 }}
                data-testid={`service-card-${s.id}`}
                className="group relative rounded-2xl border border-zinc-200 bg-white p-7 shadow-sm hover:shadow-lg hover:border-zinc-300 transition-shadow"
              >
                <div className="grid place-items-center w-11 h-11 rounded-xl bg-blue-50 text-blue-600 group-hover:bg-blue-100 transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 font-display text-lg font-medium text-zinc-900">
                  {s.title}
                </h3>
                <p className="mt-2.5 text-sm text-zinc-600 leading-relaxed">
                  {s.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
